export default "/images/growth.svg?470cb23b7bf898165a69c565ed43e1f3";